import { createRouter, createWebHistory } from 'vue-router';
import { routes } from './routes';

export const router = createRouter({
	history: createWebHistory(),
	routes,
	// Legacy screens scroll inside the iframe; only native Vue pages use the window scroll.
	scrollBehavior: (to, from, savedPosition) => (to.meta?.legacyView ? false : (savedPosition ?? { top: 0 })),
});
